import * as appConstants from "../infrastructure/appConstants";

export const normalizeNumeroDocumentoIdentidad = (value, tipoDocumento) => {
  if (tipoDocumento && value) {
    if (
      tipoDocumento === appConstants.CODIGO_TIPO_DOCUMENTO_DNI ||
      tipoDocumento === appConstants.CODIGO_TIPO_DOCUMENTO_RUC ||
      tipoDocumento === appConstants.CODIGO_TIPO_DOCUMENTO_CCEE ||
      tipoDocumento === appConstants.CODIGO_TIPO_DOCUMENTO_PTP ||
      tipoDocumento === appConstants.CODIGO_TIPO_DOCUMENTO_CR
    ) {
      return value.replace(/[^\d]/g, "");
    } else {
      return value.replace(/[^A-Za-z0-9]+/g, "");
    }
  } else {
    return value;
  }
};
export const normalizeNumero = (value) => {
  if (value) return value.replace(/[^\d]/g, "");
  return value;
};

export const normalizePassword = (value) => {
  //if (value) return value.replace(/[^a-zA-Z0-9]/g, "");
  return value;
};

export const normalizeLetrasEspacios = (value) => {
  if (!value) return value;
  return value.replace(/[^A-Za-z ñÑ]+/g, "");
};

export const getLengthNumeroDocumentoIdentidad = (tipoDocumento) => {
  if (tipoDocumento) {
    switch (tipoDocumento) {
      case appConstants.CODIGO_TIPO_DOCUMENTO_DNI:
        return appConstants.LONGITUD_TIPO_DOCUMENTO_DNI;
      case appConstants.CODIGO_TIPO_DOCUMENTO_CCEE:
        return appConstants.LONGITUD_TIPO_DOCUMENTO_CCEE;
      case appConstants.CODIGO_TIPO_DOCUMENTO_PASP:
        return appConstants.LONGITUD_TIPO_DOCUMENTO_PASP;
      case appConstants.CODIGO_TIPO_DOCUMENTO_RUC:
        return appConstants.LONGITUD_TIPO_DOCUMENTO_RUC;
      case appConstants.CODIGO_TIPO_DOCUMENTO_OTRS:
        return appConstants.LONGITUD_TIPO_DOCUMENTO_OTRS;
      case appConstants.CODIGO_TIPO_DOCUMENTO_PTP:
        return appConstants.LONGITUD_TIPO_DOCUMENTO_PTP;
      case appConstants.CODIGO_TIPO_DOCUMENTO_CI:
        return appConstants.LONGITUD_TIPO_DOCUMENTO_CI;
      case appConstants.CODIGO_TIPO_DOCUMENTO_CR:
        return appConstants.LONGITUD_TIPO_DOCUMENTO_CR;
      case appConstants.CODIGO_TIPO_DOCUMENTO_CEPR:
        return appConstants.LONGITUD_TIPO_DOCUMENTO_CEPR;
      default:
        break;
    }
  }
};
